// extracted by mini-css-extract-plugin
export default {"Privacy":"privacy_Privacy__CWRkm","Title":"privacy_Title__QWNGs","Body":"privacy_Body__5kZNw","SubTitle":"privacy_SubTitle__+uOjH"};